import { render, staticRenderFns } from "./Attribute3.vue?vue&type=template&id=138b4dd8&scoped=true"
import script from "./Attribute3.vue?vue&type=script&lang=js"
export * from "./Attribute3.vue?vue&type=script&lang=js"
import style0 from "./Attribute3.vue?vue&type=style&index=0&id=138b4dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b4dd8",
  null
  
)

export default component.exports